import { render, staticRenderFns } from "./DetailCompanyPage.vue?vue&type=template&id=3d2878e4&"
import script from "./DetailCompanyPage.vue?vue&type=script&lang=js&"
export * from "./DetailCompanyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d2878e4')) {
      api.createRecord('3d2878e4', component.options)
    } else {
      api.reload('3d2878e4', component.options)
    }
    module.hot.accept("./DetailCompanyPage.vue?vue&type=template&id=3d2878e4&", function () {
      api.rerender('3d2878e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/DetailCompanyPage.vue"
export default component.exports